import moment from 'moment'

export const getDoctorFulName = ({ name, lastNameFather, lastNameMother }) =>
  `${name} ${lastNameFather} ${lastNameMother}`.trim()

export const getFileNameDoctorReport = doctor =>
  `Reporte_Doctor?${getDoctorFulName(doctor)}_${moment().format(
    'MM-DD-YYYY'
  )}.xlsx`
